BX.Vue.component('aos__ban',
    {
        computed: {},
        data: function () {
            return {};
        },
        methods: {
            msg: function (code) {
                return BX.aBase.msg(code);
            },
        },
        mounted: function () {
            let vm = this;
            vm.$parent.ocfStepClass = 'aos__ban'
            vm.$parent.title = vm.$parent.banTitle ? vm.$parent.banTitle : vm.msg('A_AOS_BAN_TITLE');
            vm.$parent.titleClass = 'ocf__info__title';
            vm.$parent.removeMessageError();
            vm.$parent.scrollToElement('._aos', 0);
        },
        template: `
          <div class="aos__ban">
          <div class="ocf__block ocf__info-wrap">
            <div class="ocf__info">
              <div class="ocf__info-block">
                <div class="ocf__info-desc" v-html="$parent.banText ? $parent.banText : msg('A_AOS_BAN_DESC')"></div>
              </div>
            </div>
          </div>
          </div>
        `,
    }
);